import { render } from "./VerticalNavbar.vue?vue&type=template&id=2977ec58&scoped=true&ts=true"
import script from "./VerticalNavbar.vue?vue&type=script&lang=ts"
export * from "./VerticalNavbar.vue?vue&type=script&lang=ts"

import "./VerticalNavbar.vue?vue&type=style&index=0&id=2977ec58&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2977ec58"]])

export default __exports__